/** @format */

import { styled } from "@mui/material/styles";
import {
	CardMedia,
	Paper,
	Typography,
	Theme,
	Button,
	Box,
} from "@mui/material";
import React from "react";
import { colors, fontSize } from "../../utility/types/constant";

export const ContentWrapper = styled("div")(({ theme }) => ({
	display: "flex",
	flexDirection: "column",
	justifyContent: "center",
	width: "100%",
	maxWidth: "100%",
	margin: "0 auto",
	boxSizing: "border-box",
	position: "relative",
	background: colors.primary,
	color: "#fff",
	fontFamily: "'Roboto Condensed', sans-serif",
	paddingBottom: "80px",
	paddingTop: "80px",
	borderRadius: "0px",
	alignItems: "center",
	overflow: "hidden",
	[theme.breakpoints.down("sm")]: {
		paddingLeft: "16px",
		paddingRight: "16px",
		overflow: "visible",
	},
}));

export const Item = styled(Paper)(({ theme }) => ({
	backgroundColor: "#FFFFFF",
	...theme.typography.body2,
	padding: theme.spacing(1),
	textAlign: "center",
	color: theme.palette.text.secondary,

	position: "relative",
	display: "flex",
	justifyContent: "flex-end",
	width: "100%",

	[theme.breakpoints.down("sm")]: {
		// marginBottom: theme.spacing(2), // Creates space between the image and content on small screens
		width: "100% !important",
		// height: '100%',
		// position: 'relative',
		// left:'0',
		justifyContent: "center",
		// padding:'100px',
		alignItems: "center",
	},
}));

export const BannerContainer = styled("div")(({ theme }) => ({
	position: "relative",
	[theme.breakpoints.down("sm")]: {
		height: "auto",
	},
	// Creates space between the navbar and banner
	paddingTop: theme.spacing(2),
}));

export const BannerHeaderTypography = styled(Typography)(({ theme }) => ({
	fontFamily: "'Montserrat', sans-serif",
	fontSize: "clamp(2.5rem, 5vw, 4rem)",
	fontWeight: 800,
	width: "80%",
	maxWidth: "1200px",
	wordBreak: "break-word",
	justifyContent: "center",
	alignItems: "center",
	display: "flex",
	margin: "0 auto",
	textAlign: "center",
	flexDirection: "column",
	lineHeight: 1.2,
	letterSpacing: "-0.02em",
	textShadow: "0 2px 20px rgba(0,0,0,0.1)",
	position: "relative",
	zIndex: 1,

	[theme.breakpoints.down("md")]: {
		width: "90%",
		fontSize: "clamp(2rem, 5vw, 3rem)",
	},

	[theme.breakpoints.down("sm")]: {
		width: "95%",
		fontSize: "clamp(1.75rem, 5vw, 2.5rem)",
	},
}));

export const SectionWrapper = styled("div")(({ theme }) => ({
	paddingTop: "40px",
	paddingBottom: "40px",
	justifyContent: "center",
	width: "90%",
	wordWrap: "break-word",
	display: "flex",
	flexDirection: "column",
	alignItems: "center",
	backgroundColor: "transparent",
}));

export const ContentContainer = styled("div")(({ theme }) => ({
	padding: theme.spacing(2),
	zIndex: 2,

	width: "60%",
	// position: 'absolute',
	// left: '70%',
	// top: '50%',
	transform: "translate(-50%, -50%)", // This centers the content over the image
	backgroundColor: "rgba(255, 255, 255, 0.8)",

	[theme.breakpoints.down("sm")]: {
		width: "100%",
		backgroundColor: "transparent",
		// backgroundColor: 'green',
		// padding: '1px',
		justifyContent: "center",
		// padding: theme.spacing(2),
		position: "absolute",
		left: "50%",
		top: "50%",
		transform: "translate(-50%, -50%)",
		// paddingTop: '10px',
		// paddingBottom: '10px',
		alignItems: "center",
	},

	[theme.breakpoints.up("md")]: {
		position: "absolute", // Position content over the image
		left: "45%", // Adjust the percentage as needed to overlap the image
		top: "50%",
		transform: "translate(-50%, -50%)",
		width: "55%", // Adjust width as needed
		backgroundColor: "rgba(255, 255, 255, 0.8)",
	},
}));

export const StyledTypography = styled(Typography)(({ theme }) => ({
	fontFamily: "'Montserrat', sans-serif",
	fontSize: "clamp(1.125rem, 2vw, 1.5rem)",
	fontWeight: 400,
	width: "70%",
	maxWidth: "800px",
	wordBreak: "break-word",
	textAlign: "center",
	lineHeight: 1.7,
	color: colors.primary,
	position: "relative",
	zIndex: 1,
	marginBottom: "30px",
	[theme.breakpoints.down("md")]: {
		width: "85%",
		fontSize: "clamp(1rem, 2vw, 1.25rem)",
	},
	[theme.breakpoints.down("sm")]: {
		width: "95%",
		justifyContent: "center",
		textAlign: "center",
		alignItems: "center",
	},
}));

type StyledCardMediaProps = React.ComponentProps<typeof CardMedia> & {
	component?: string;
	alt?: string;
};

export const StyledCardMedia = styled(CardMedia)<StyledCardMediaProps>(
	({ theme }: { theme: Theme }) => ({
		[theme.breakpoints.down("md")]: {
			height: "50vh",
			borderRadius: "2px",
		},
		[theme.breakpoints.down("sm")]: {
			height: "50vh",
			borderRadius: "2px",
			width: "100%",
		},
	})
);

export const ImageOverlapContainer = styled("div")(({ theme }) => ({
	position: "relative",
	width: "100%",
	height: "100vh",
	[theme.breakpoints.down("md")]: {
		// Adjustments for medium screens
	},
	[theme.breakpoints.down("sm")]: {
		// Adjustments for small screens
	},
}));

// Modern CTA Button Styles
export const CTAButtonsWrapper = styled(Box)(({ theme }) => ({
	display: "flex",
	gap: "20px",
	justifyContent: "center",
	alignItems: "center",
	marginTop: "30px",
	flexWrap: "wrap",
	position: "relative",
	zIndex: 1,
	[theme.breakpoints.down("sm")]: {
		gap: "15px",
		flexDirection: "column",
		width: "100%",
	},
}));

export const PrimaryCTAButton = styled(Button)(({ theme }) => ({
	backgroundColor: colors.mainSecondary,
	color: "#ffffff",
	padding: "14px 40px",
	fontSize: "1.125rem",
	fontWeight: 600,
	textTransform: "none",
	borderRadius: "50px",
	boxShadow: "0 8px 20px rgba(0,0,0,0.2)",
	transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
	fontFamily: "'Montserrat', sans-serif",
	"&:hover": {
		backgroundColor: colors.headerColor,
		transform: "translateY(-3px)",
		boxShadow: "0 12px 30px rgba(30,193,149,0.4)",
	},
	[theme.breakpoints.down("sm")]: {
		width: "90%",
		padding: "12px 30px",
	},
}));

export const SecondaryCTAButton = styled(Button)(({ theme }) => ({
	borderColor: "rgba(255,255,255,0.9)",
	color: "#ffffff",
	padding: "14px 40px",
	fontSize: "1.125rem",
	fontWeight: 600,
	textTransform: "none",
	borderRadius: "50px",
	borderWidth: "2px",
	transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
	fontFamily: "'Montserrat', sans-serif",
	"&:hover": {
		borderColor: "#ffffff",
		backgroundColor: "rgba(255,255,255,0.15)",
		transform: "translateY(-3px)",
		borderWidth: "2px",
	},
	[theme.breakpoints.down("sm")]: {
		width: "90%",
		padding: "12px 30px",
	},
}));

// Floating Icon Animation
export const FloatingIcon = styled(Box)(({ theme }) => ({
	position: "absolute",
	animation: "float 6s ease-in-out infinite",
	"@keyframes float": {
		"0%, 100%": {
			transform: "translateY(0px)",
		},
		"50%": {
			transform: "translateY(-20px)",
		},
	},
	[theme.breakpoints.down("md")]: {
		display: "none",
	},
}));

// Gradient Text
export const GradientText = styled("span")(({ theme }) => ({
	color: colors.mainSecondary,
	fontWeight: 900,
}));

export const BannerSubtitle = styled(Typography)(({ theme }) => ({
	fontFamily: "'Montserrat', sans-serif",
	fontSize: "clamp(1.1rem, 2vw, 1.5rem)",
	fontWeight: 400,
	color: "rgba(255,255,255,0.88)",
	textAlign: "center",
	lineHeight: 1.65,
	maxWidth: "700px",
	margin: "20px auto 0",
	position: "relative",
	zIndex: 1,
	[theme.breakpoints.down("md")]: {
		fontSize: "clamp(1rem, 2vw, 1.25rem)",
		maxWidth: "90%",
	},
	[theme.breakpoints.down("sm")]: {
		fontSize: "1rem",
		maxWidth: "100%",
		padding: "0 4px",
	},
}));

export const SeeHowButton = styled(Button)(({ theme }) => ({
	backgroundColor: colors.primary,
	color: "#ffffff",
	padding: "12px 36px",
	fontSize: "1rem",
	fontWeight: 600,
	textTransform: "none",
	borderRadius: "50px",
	boxShadow: "0 8px 20px rgba(4,13,69,0.35)",
	fontFamily: "'Montserrat', sans-serif",
	transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
	"&:hover": {
		backgroundColor: colors.primary,
		transform: "translateY(-2px)",
		boxShadow: "0 12px 30px rgba(4,13,69,0.45)",
	},
	[theme.breakpoints.down("sm")]: {
		width: "90%",
		padding: "10px 28px",
	},
}));

export const TryDemoCTAButton = styled(Button)(({ theme }) => ({
	backgroundColor: "transparent",
	color: colors.mainSecondary,
	border: `2px solid ${colors.mainSecondary}`,
	padding: "14px 40px",
	fontSize: "1.125rem",
	fontWeight: 600,
	textTransform: "none",
	borderRadius: "50px",
	marginTop: "28px",
	transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
	fontFamily: "'Montserrat', sans-serif",
	"&:hover": {
		border: `2px solid ${colors.mainSecondary}`,
		backgroundColor: "rgba(30,193,149,0.12)",
		transform: "translateY(-3px)",
	},
	[theme.breakpoints.down("sm")]: {
		width: "90%",
		padding: "12px 30px",
	},
}));

export const BrandText = styled("span")({
	color: colors.mainSecondary,
	fontWeight: 800,
	display: "inline-block",
	animation: "brandPulse 2.5s ease-in-out infinite",
	"@keyframes brandPulse": {
		"0%, 100%": { opacity: 1, transform: "scale(1)" },
		"50%": { opacity: 0.75, transform: "scale(1.04)" },
	},
});

export const BaseImage = styled(CardMedia)(({ theme }) => ({
	position: "absolute",
	zIndex: 1,
	width: "100%", // Full width of the parent container
	height: "auto", // Keep aspect ratio
	top: 0,
	left: "25%",
	transform: "translateX(-50%)", // Center horizontally

	[theme.breakpoints.down("md")]: {
		top: "0",
		left: "50%",
		transform: "translateX(-50%)",
	},
	[theme.breakpoints.down("sm")]: {
		top: "0",
		left: "50%",
		transform: "translateX(-50%)",
		zIndex: 2, // Keep it on top on small screens
	},
}));

// Define the second image component with styled-components
export const OverlapImage = styled(CardMedia)(({ theme }) => ({
	position: "absolute",
	zIndex: 2,
	// width: '800px',
	// top: '150px',
	// left: '290px',

	width: "100%", // Full width of the parent container
	height: "auto", // Keep aspect ratio
	top: "15%", // Adjust top position as needed
	left: "75%",
	transform: "translateX(-50%)", // Center horizontally

	[theme.breakpoints.down("md")]: {
		top: "15%",
		left: "50%",
		transform: "translateX(-50%)",
	},
	[theme.breakpoints.down("sm")]: {
		top: "23%", // You may want to adjust this for small screens
		// left: '50%',
		// transform: 'translateX(-50%)',

		//   position: 'relative', // Reset to flow in the document
		zIndex: 1, // Ensure it stays below the BaseImage
		// top: 'initial', // Reset top position
		left: "initial", // Reset left position
		transform: "initial", // Reset transform
		marginTop: "56.25%", // Push down by the aspect ratio of the BaseImage, adjust as needed
	},
}));
